import ConfirmModal from '@components/modal/ConfirmModal';
import { useEffect } from 'react';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';
import useDeleteContactUsMessage from './hooks/useDeleteContactUsMessage';

const DeleteContactUsMessageModal: React.FC<DeleteMessageProps> = ({ message, closeModal }) => {
    const { handleSubmit, isDeleting, wasDeleting, deleteError } = useDeleteContactUsMessage(
        message.id,
    );

    useEffect(() => {
        if (!isDeleting && wasDeleting) closeModal();
    }, [isDeleting, wasDeleting, closeModal]);

    return (
        <ConfirmModal
            title="Delete message"
            description={`Are you sure you want to delete this message from '${message.firstName} ${message.lastName}'?`}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            isPosting={isDeleting}
            error={deleteError}
        />
    );
};

interface DeleteMessageProps {
    message: ContactUsMessage;
    closeModal: () => void;
}
export default DeleteContactUsMessageModal;
